import IconMenu from '@shared/icons/IconMenu';
import { Link } from '@tanstack/react-router';

import { useAuth } from '@/context/auth';
import { Theme, useTheme } from '@/context/theme';
import { useTenantAssetRefresh } from '@/hooks/useTenantAssetRefresh';

interface MobileHeaderProps {
  onToggleSidebar: () => void;
}

export const MobileHeader: React.FC<MobileHeaderProps> = ({ onToggleSidebar }) => {
  const { theme } = useTheme();
  const { tenant } = useAuth();
  // EWM-548: re-fetch a fresh SAS logo URL if the stored one has expired (403 -> img error).
  const { onAssetError, reset } = useTenantAssetRefresh();

  return (
    <header className='dark:bg-c16 sticky top-0 z-[151] mt-1 flex h-14 items-center justify-between rounded-xl bg-white px-4 shadow-xs lg:hidden dark:border-gray-700'>
      <button
        onClick={onToggleSidebar}
        className='flex h-10 w-10 items-center justify-center rounded-lg transition-colors hover:bg-gray-100 dark:hover:bg-gray-700'
      >
        <IconMenu className='h-8 w-8' />
      </button>
      <div className='flex items-center space-x-4'>
        <Link to='/' className='flex min-w-[40px] items-center justify-center'>
          <img
            src={(theme === Theme.light ? tenant?.logoUrl : tenant?.darkModeLogoUrl) || undefined}
            className='max-h-10 max-w-28'
            alt='Logo'
            onError={onAssetError}
            onLoad={reset}
          />
        </Link>
      </div>
    </header>
  );
};
